/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;box-sizing:border-box;margin-left:20px;margin-right:20px}.logo[_ngcontent-%COMP%]{-o-object-fit:contain;object-fit:contain}"];
export { styles as styles };
